import { motion } from "framer-motion";

export function Reveal({ children, className = "", delay = 0, y = 28 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeader({ eyebrow, title, text, dark = false }) {
  return (
    <div className="max-w-3xl">
      <Reveal>
        <p className={`flex items-center gap-2 text-xs font-black uppercase tracking-[0.2em] ${dark ? "text-[var(--yellow)]" : "text-[var(--blue-deep)]"}`}>
          <span className={`inline-block w-2.5 h-2.5 ${dark ? "bg-[var(--yellow)]" : "bg-[var(--blue)]"}`} aria-hidden="true" />
          {eyebrow}
        </p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="font-display font-extrabold tracking-tight leading-[1.08] text-3xl md:text-5xl mt-4">{title}</h2>
      </Reveal>
      {text ? (
        <Reveal delay={0.16}>
          <p className={`mt-5 text-lg md:text-xl leading-relaxed ${dark ? "text-[#c9cfd6]" : "text-[var(--muted)]"}`}>{text}</p>
        </Reveal>
      ) : null}
    </div>
  );
}
